import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function TextColumn(props: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const { value } = props;
  const displayValue = value ? (value as string).replaceAll(' ', '\xa0') : value;
  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{displayValue}</Typography>
    </Box>
  );
}
